import Index from './Index.vue';

export default {
  path: 'campanhas',
  name: 'campanha',
  component: Index,
};
